export default "__VITE_PUBLIC_ASSET__571247d8__"